import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import * as msTeams from '@microsoft/teams-js'
import { mapGetters } from 'vuex'
import * as baseTypes from '@appbase/store/types'
import TeamsHelper from '@appbase/util/teams-helper'

import api from '@appbase/api'



// ─────────────────────────────────────────────────────────────────────────────
// ─── 팀즈앱의 진입점으로 사용되는 컴포넌트입니다. ───────────────────────────────────
// ─── 팀즈앱의 진입점은 매니페스트에서 지정할 수 있습니다. ────────────────────────────
// ─────────────────────────────────────────────────────────────────────────────


@Component({
    computed: {
        ...mapGetters({
            isTeams: baseTypes.TEAMS
        }),
    },
})
export default class TeamsEntryView extends Vue {

    // ─── Data ────────────────────────────────────────────────────────────

    currentBaseUrl = window.location.origin;

    subEntityIdObj: teamsentry.Payload = {
        action: undefined,
        payload: undefined
    };

    teamsHelper = new TeamsHelper();


    // ─── Getters ────────────────────────────────────────────────────────

    isTeams!: boolean


    // ─── Methods ─────────────────────────────────────────────────────────

    redirectBySubEntityId() {
        const payload = this.subEntityIdObj.payload;

        if (!payload || !payload.relativeUrl) {
            console.error('TeamsEntry: payload for redirect is invalid.');
            this.redirectToHome()
            return;
        }

        console.error('redirectBySubEntityId: ' + this.currentBaseUrl + payload.relativeUrl);

        try {
            document.location.href = this.currentBaseUrl + payload.relativeUrl;
        } catch (e) {
            console.error(e);
        }

    }

    redirectToHome() {
        document.location.href = this.currentBaseUrl;
    }


    // ─── Lifecycle ───────────────────────────────────────────────────────

    async created() { }

    async mounted() {
        if (this.isTeams) {
            this.subEntityIdObj = await this.teamsHelper.uGetTeamsSubEntityIdObj();
        }

        try {
            if (this.isTeams && this.subEntityIdObj && this.subEntityIdObj.action) {
                //console.error('uGetTeamsDeepLink: ', uGetTeamsDeepLink(this.subEntityIdObj));

                switch (this.subEntityIdObj.action) {
                    case 'redirect':
                        this.redirectBySubEntityId()
                        break;
                    default:
                        throw new Error('TeamsEntry: action is invalid. action: ' + this.subEntityIdObj.action);
                }
            } else {
                console.log('No Teams action detected. Redirect to home.');
                this.redirectToHome()
            }
        } catch (e) {
            console.error(e);
            this.redirectToHome()
        }
    }
}